import { combineReducers } from "redux-immutable";
import { reducer as navigationBar } from "../pages/navigationBar/store";
import { reducer as BasicManagement } from "../pages/BasicManagement/store/";
import { reducer as Maps } from "../pages/Map/store/";
import { reducer as maintain } from "../pages/maintain/store";
import { reducer as statistics1 } from "../pages/statistics1/store";
import { reducer as statistics2 } from "../pages/statistics2/store";
import { reducer as feedbackList } from "../pages/feedbackList/store";
import { reducer as contentManagement } from "../pages/contentManagement/store";
import { reducer as MassivePoint } from "../pages/MassivePoint/store";

const reducer = combineReducers({
  navigationBar: navigationBar,
  BasicManagement: BasicManagement,
  Maps: Maps,
  maintain: maintain,
  statistics1: statistics1,
  statistics2: statistics2,
  feedbackList: feedbackList,
  contentManagement: contentManagement,
  MassivePoint: MassivePoint,
});

export default reducer;
